export default __webpack_public_path__ + "static/809-f34d47adef95a6979a04eba7b86d9013.gif";